<ul class="link-chips" *ngIf="chips?.length">
    <li #chip class="link-chips__chip" *ngFor="let item of visibleChips">
        <span class="link-chips__label">{{item.label}}</span>
        <button *ngIf="!readonly" type="button" class="link-chips__remove" [attr.aria-label]="item.label"
            (click)="remove.emit(item)">&times;</button>
    </li>
    <li *ngIf="hiddenCount > 0" class="link-chips__chip link-chips__chip--more">{{moreLabel(hiddenCount)}}</li>
</ul>
